import { render, staticRenderFns } from "./ThgClosing.vue?vue&type=template&id=0f7863bd&scoped=true"
import script from "./ThgClosing.vue?vue&type=script&lang=ts"
export * from "./ThgClosing.vue?vue&type=script&lang=ts"
import style0 from "./ThgClosing.vue?vue&type=style&index=0&id=0f7863bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7863bd",
  null
  
)

export default component.exports